import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, Tag } from 'lucide-react';
import { businessInfo } from '../mock';

const PromoContent = ({ onClaim }) => (
  <div>
    <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white px-4 py-2 rounded-full mb-6 text-sm font-semibold uppercase tracking-wider">
      <Tag size={16} />
      Limited Time Offer
    </div>
    <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
      <span className="text-yellow-300">$99 Discount</span> on Roof Repairs
    </h2>
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 mb-6 border border-white/20">
      <p className="text-white text-lg font-semibold mb-1">Senior Citizens Discount</p>
      <p className="text-white/90 text-base">
        Get an <span className="text-yellow-300 font-bold">additional 5% off</span> on all plumbing works.
      </p>
    </div>
    <p className="text-white/95 text-lg mb-8">
      Don't miss out — book today and let our licensed team take care of it.
    </p>
    <div className="flex flex-col sm:flex-row gap-4">
      <button
        onClick={onClaim}
        data-testid="promo-quote-btn"
        className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 hover:bg-yellow-300 hover:text-slate-900 px-7 py-4 rounded-lg font-bold text-base transition-all duration-200 shadow-lg hover:shadow-xl"
      >
        I Want This Discount
      </button>
      <a
        href={`tel:${businessInfo.phoneRaw}`}
        data-testid="promo-call-btn"
        className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 px-7 py-4 rounded-lg font-bold text-base transition-all duration-200"
      >
        <Phone size={18} />
        Call {businessInfo.phone}
      </a>
    </div>
  </div>
);

const DiscountVisual = () => (
  <div className="hidden lg:flex justify-center">
    <div className="relative">
      <div className="bg-white rounded-3xl p-10 shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
        <div className="text-center">
          <div className="text-xs font-bold text-red-600 uppercase tracking-widest mb-2">Save</div>
          <div className="text-7xl font-bold text-blue-600 leading-none mb-1">$99</div>
          <div className="text-slate-600 font-semibold mb-5">on Roof Repairs</div>
          <div className="h-px bg-slate-200 mb-5" />
          <div className="text-xs font-bold text-red-600 uppercase tracking-widest mb-2">Plus</div>
          <div className="text-5xl font-bold text-red-600 leading-none mb-1">5% OFF</div>
          <div className="text-slate-600 font-semibold text-sm">Seniors on Plumbing</div>
        </div>
      </div>
    </div>
  </div>
);

const PromoBanner = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden py-20 md:py-24 bg-blue-600">
      <div className="absolute inset-y-0 right-0 w-full md:w-1/2 bg-red-600 skew-x-12 translate-x-32 md:translate-x-24 pointer-events-none" />
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 left-10 w-72 h-72 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-10 w-72 h-72 bg-white rounded-full blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <PromoContent onClaim={() => navigate('/contact')} />
          <DiscountVisual />
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
